<template>
  <svg
    class="spinner"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style="fill-rule: evenodd; clip-rule: evenodd; stroke-linecap: round;"
  >
    <g transform="matrix(0.888889,0,0,0.888889,0,2.22222)">
      <g transform="matrix(1,0,0,1,0,4.5)">
        <path
          d="M4.538,3L0.462,3C0.207,3 0,2.79 0,2.532C0,2.407 0.049,2.288 0.136,2.2L2.174,0.137C2.354,-0.046 2.646,-0.046 2.826,0.137L4.864,2.2C5.045,2.383 5.045,2.68 4.865,2.863C4.778,2.951 4.661,3 4.538,3Z"
          style="fill: rgb(75, 75, 75); fill-rule: nonzero;"
        />
        <path
          d="M2.5,2C2.5,5.59 5.41,8.5 9,8.5C10.506,8.5 11.892,7.988 12.994,7.129"
          style="fill: none; stroke: rgb(75, 75, 75); stroke-width: 1px;"
        />
      </g>
      <g transform="matrix(-1,7.65714e-16,-7.65714e-16,-1,18,8.5)">
        <path
          d="M4.538,3L0.462,3C0.207,3 0,2.79 0,2.532C0,2.407 0.049,2.288 0.136,2.2L2.174,0.137C2.354,-0.046 2.646,-0.046 2.826,0.137L4.864,2.2C5.045,2.383 5.045,2.68 4.865,2.863C4.778,2.951 4.661,3 4.538,3Z"
          style="fill: rgb(75, 75, 75); fill-rule: nonzero;"
        />
        <path
          d="M2.5,2C2.5,5.59 5.41,8.5 9,8.5C10.506,8.5 11.892,7.988 12.994,7.129"
          style="fill: none; stroke: rgb(75, 75, 75); stroke-width: 1px;"
        />
      </g>
    </g>
  </svg>
</template>
<style lang="scss" scoped>
.spinner {
  width: 16px;
  height: 16px;

  animation: spin 1s infinite linear;
  @keyframes spin {
    25% {
      transform: rotate(90deg);
    }
    50% {
      transform: rotate(180deg);
    }
    75% {
      transform: rotate(270deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
